<template>
  <a-popover v-model="visible" title="详情" trigger="hover">
    <div class="long-text-content" slot="content">{{ text }}</div>
    <div class="three-ellipsis long-text">{{text}}</div>
  </a-popover>
</template>

<script>

    export default {
        name: "long-text",
        props: {
            text: String
        },
        data() {
            return {
                visible: false
            }
        }
    }
</script>

<style lang="less">
  .long-text {
    cursor: pointer;
  }
  .long-text-content {
    width: 300px;
    text-indent: 2em;
  }
</style>
